module.exports = __webpack_public_path__ + "img/FAQs 2.e63fbf05.png";